import React, { useEffect, useState } from 'react';
import "./StartPage.css";
import TablePic from "./table.png"
import AvatarBar from "../AvatarBar/AvatarBar"
import useWebSocket, { ReadyState } from 'react-use-websocket';
import AvatarIcon from '../AvatarIcon/AvatarIcon';
import { MAKE_GAME_URL, START_PAGE_WS_URL } from "../../lib/serverConfig";
import { parseSocketMessage } from "../../lib/socketMessage";

const WS_URL = START_PAGE_WS_URL;
const AI_SEAT_OPTIONS = [
    { id: "tiedeman", label: "Tiedeman" },
    { id: "kathy", label: "Kathy" },
    { id: "uncle_jim", label: "Uncle Jim" },
];

function StartPage(props) {
    const [renderJoinStart, setRenderJoinStart] = useState(false);
    const [renderUserNameBar, setRenderUserNameBar] = useState(true);
    const [renderAvatarChoiceBar, setRenderAvatarChoiceBar] = useState(false);
    const [renderJoinUI, setRenderJoinUI] = useState(false);
    const [joined, setJoined] = useState(false);
    const [gameNotFound, setGNF] = useState(false);
    const [aiPickerSpot, setAiPickerSpot] = useState(null);
    const [showLeaveLobbyPrompt, setShowLeaveLobbyPrompt] = useState(false);
    const seatConfig = {
        1: { className: "lobbySeat lobbySeat1", reverse: true, user: props.user1, logo: props.lcode1 },
        2: { className: "lobbySeat lobbySeat2", reverse: true, user: props.user2, logo: props.lcode2 },
        3: { className: "lobbySeat lobbySeat3", reverse: false, user: props.user3, logo: props.lcode3 },
        4: { className: "lobbySeat lobbySeat4", reverse: false, user: props.user4, logo: props.lcode4 },
    };

    const { sendJsonMessage, lastMessage, readyState } = useWebSocket(WS_URL, {
        onOpen: () => {
          console.log("StartPageSocket connection established.");
        },
        onClose: () => {
            if (readyState === ReadyState.OPEN) {
                sendJsonMessage({
                  event: "closeStartPageWS",
                  gameCode: props.gameCode
                })
              }
        },
         // filter: () => false,
        retryOnError: true,
        shouldReconnect: () => true,
        
      });
  

      


      useEffect(() => {
        if (JSON.parse(localStorage.getItem("uid")) != null)
        {
            loadFromStorage()
        }
        // else
        // {
        //     setStorage()
        // }
      }, [])

      useEffect(() => {
        console.log("Connection state changed to StartPageSocket")
        if (readyState === ReadyState.OPEN && JSON.parse(localStorage.getItem("uid")) === null) {
            sendJsonMessage({
              event: "openSocket"
            })
        }
        if (readyState === ReadyState.OPEN && JSON.parse(localStorage.getItem("uid")) !== null) {
            sendJsonMessage({
                event: "updateSocketConnection",
                uid: JSON.parse(localStorage.getItem("uid")),
                gameCode: props.gameCode
            })
        }

      }, [readyState])

      useEffect(() => {
        const listener = event => {
          if (event.code === "Enter" || event.code === "NumpadEnter") {
            event.preventDefault();
            enterHandler();
 
        }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      }, [renderUserNameBar, renderJoinStart, props.gameCode]);

      useEffect(() => {
        if (lastMessage !== null)
        {
            const data = parseSocketMessage(lastMessage);
            if (!data) {
                return;
            }
            console.log(data)

            if (data["event"] === "uidPush")
            {
                localStorage.setItem("uid", JSON.stringify(data["uid"]))
            }

            if (data["event"] === "noGameForUid")
            {
                // setStorage()
                loadFromStorage()
                props.setHomeStorage()
                props.loadHomeFromStorage()
            }

            if (data["event"] === "spotPush")
            {
                for (var i = 1; i < 5; i++)
                {
                    var text1 = "user"
                    var text2 = "lcode"
                    const userString = text1.concat(i.toString()) 
                    const logoString = text2.concat(i.toString()) 
                    props.setUsers(i, data[userString] || "")
                    props.setLogos(i, data[logoString] || "")
                }
            }

            if (data["event"] === "gameExistsPush")
            {
                if (data["gameExists"])
                {
                    joinFully()
                }
                else
                {
                    localStorage.setItem("gameNotFound", JSON.stringify(true))
                    setGNF(true)
                }
            }

            if (data["event"] === "beginGamePush")
            {
                props.beginGame()
            }
        }
      }, [lastMessage])

    const loadFromStorage = () => {
        setRenderJoinStart(JSON.parse(localStorage.getItem("renderJoinStart")))
        setRenderUserNameBar(JSON.parse(localStorage.getItem("renderUserNameBar")))
        setRenderAvatarChoiceBar(JSON.parse(localStorage.getItem("renderAvatarChoiceBar")))
        setRenderJoinUI(JSON.parse(localStorage.getItem("renderJoinUI")))
        setJoined(JSON.parse(localStorage.getItem("joined")))
        setGNF(JSON.parse(localStorage.getItem("gameNotFound")))
    }

    const setStorage = () => {
        localStorage.setItem("renderJoinStart", JSON.stringify(false))
        localStorage.setItem("renderUserNameBar", JSON.stringify(true))
        localStorage.setItem("renderAvatarChoiceBar", JSON.stringify(false))
        localStorage.setItem("renderJoinUI", JSON.stringify(false))
        localStorage.setItem("joined", JSON.stringify(false))
        localStorage.setItem("gameNotFound", JSON.stringify(false))
        localStorage.setItem("myHand", JSON.stringify([]))
        localStorage.setItem("myHandTrue", JSON.stringify([]))
        localStorage.setItem("dealerLocal", JSON.stringify(""))
        localStorage.setItem("cc2", JSON.stringify(0))
        localStorage.setItem("cc3", JSON.stringify(0))
        localStorage.setItem("cc4", JSON.stringify(0))
        localStorage.setItem("dealingAnimation", JSON.stringify(false))
        localStorage.setItem("dealingAnimationFill", JSON.stringify(false))
        localStorage.setItem("handMount", JSON.stringify(true))
        localStorage.setItem("playedCard1", JSON.stringify(""))
        localStorage.setItem("playedCard2", JSON.stringify(""))
        localStorage.setItem("playedCard3", JSON.stringify(""))
        localStorage.setItem("playedCard4", JSON.stringify(""))
        localStorage.setItem("currentDealer", JSON.stringify(""))
        localStorage.setItem("waitForDealer", JSON.stringify(false))
        localStorage.setItem("currentBidder", JSON.stringify(""))
        localStorage.setItem("bidHolder", JSON.stringify(""))
        localStorage.setItem("bid", JSON.stringify("0"))
        localStorage.setItem("bidCycle", JSON.stringify(false))
        localStorage.setItem("suitCycle", JSON.stringify(false))
        localStorage.setItem("bidWinner", JSON.stringify(""))
        localStorage.setItem("suit", JSON.stringify(""))
        localStorage.setItem("discCycle", JSON.stringify(false))
        localStorage.setItem("confirmedWaiting", JSON.stringify(false))
        localStorage.setItem("fillCycle", JSON.stringify(false))
        localStorage.setItem("fill1", JSON.stringify(0))
        localStorage.setItem("fill2", JSON.stringify(0))
        localStorage.setItem("fill3", JSON.stringify(0))
        localStorage.setItem("fill4", JSON.stringify(0))
        localStorage.setItem("RRD", JSON.stringify(false))
        localStorage.setItem("flippedCardAvailable", JSON.stringify(false))
        localStorage.setItem("flippedCard", JSON.stringify(""))
        localStorage.setItem("passedTo", JSON.stringify(""))
        localStorage.setItem("passed", JSON.stringify(false))
        localStorage.setItem("cardsRemInDeck", JSON.stringify(0))
        localStorage.setItem("playCycleFlag", JSON.stringify(false))
        localStorage.setItem("waitingOn2Play", JSON.stringify(""))
        localStorage.setItem("t1PtsThisRound", JSON.stringify(0))
        localStorage.setItem("t2PtsThisRound", JSON.stringify(0))
        localStorage.setItem("t1Pts", JSON.stringify(0))
        localStorage.setItem("t2Pts", JSON.stringify(0))
        localStorage.setItem("trickWinner", JSON.stringify(""))
        localStorage.setItem("trickWinnerCycle", JSON.stringify(false))
        localStorage.setItem("gameOverFlag", JSON.stringify(false))
        localStorage.setItem("winningTeam", JSON.stringify(-1))
    }

    const enterHandler = () => {
        if (renderUserNameBar)
        {
            searchgo();
        }
        if (renderJoinStart)
        {
            handleJoinClick();
        }
    }

    const searchHandler = (event) => {
        props.setUsername(event)
    }

    const joinHandler = (event) => {
        props.setGameCode(event)
    }

    const startGame = () => {
        fetch(MAKE_GAME_URL).then((response) => response.json()).then((data) => {
            props.setGameCodeOnStart(data.gameCode);
            props.setLobbyLeader();
            const result = data.gameCode;
            return result
            }).then((result) => registerForGame(result))
    }

    const handleStartClick = () => {
        startGame();
        localStorage.setItem("renderJoinStart", JSON.stringify(false))
        setRenderJoinStart(false);
        localStorage.setItem("renderJoinUI", JSON.stringify(true))
        setRenderJoinUI(true);
    }

    const registerForGame = (result) => {
        if (readyState === ReadyState.OPEN) {
            sendJsonMessage({
              event: "registerForGame",
              uid: JSON.parse(localStorage.getItem("uid")),
              gameCode: result
            })
          }
    }

    const checkIfGameExists = (result) => {
        localStorage.setItem("gameNotFound", JSON.stringify(false))
        setGNF(false)
        if (readyState === ReadyState.OPEN) {
            sendJsonMessage({
              event: "gameCheck",
              gameCode: result
            })
          }
    }

    const joinFully = () => {
        localStorage.setItem("renderJoinStart", JSON.stringify(false))
        setRenderJoinStart(false);
        localStorage.setItem("renderJoinUI", JSON.stringify(true))
        setRenderJoinUI(true);
        registerForGame(props.gameCode)
    }

    const handleJoinClick = () => {
        checkIfGameExists(props.gameCode);
    }

    const handleSpotClick = (spot) => {
        if (!joined) {
            if (readyState === ReadyState.OPEN) {
                sendJsonMessage({
                  event: "spotDecision",
                  gameCode: props.gameCode,
                  uid: JSON.parse(localStorage.getItem("uid")),
                  userName: props.username,
                  logoCode: props.logoCode,
                  spotChoice: String(spot),
                })
              }
            localStorage.setItem("joined", JSON.stringify(true))
            setJoined(true)
            props.setMySpot(spot)
        }
    }

    const handleBeginClick = () => {

        if (readyState === ReadyState.OPEN) {
            sendJsonMessage({
              event: "beginGame",
              gameCode: props.gameCode,
              userName: props.username,
            })
          }
    }

    const leaveLobby = () => {
        if (readyState === ReadyState.OPEN && JSON.parse(localStorage.getItem("uid")) !== null && props.gameCode !== "") {
            sendJsonMessage({
              event: "leaveLobby",
              gameCode: props.gameCode,
              uid: JSON.parse(localStorage.getItem("uid")),
            })
        }

        props.setHomeStorage()
        props.loadHomeFromStorage()
        setAiPickerSpot(null)
        setShowLeaveLobbyPrompt(false)
    }

    const handleAddAiClick = (spot, profileId) => {
        if (readyState === ReadyState.OPEN) {
            sendJsonMessage({
              event: "addAiSeat",
              gameCode: props.gameCode,
              uid: JSON.parse(localStorage.getItem("uid")),
              spotChoice: String(spot),
              profileId,
            })
          }
        setAiPickerSpot(null)
    }

    const handleAvatarClickLocal = (avatarId) => {
        props.handleAvatarClick(avatarId)
        avatargo()
    }

    const searchgo = () => {
        localStorage.setItem("renderAvatarChoiceBar", JSON.stringify(true))
        setRenderAvatarChoiceBar(true)
        localStorage.setItem("renderUserNameBar", JSON.stringify(false))
        setRenderUserNameBar(false)
    }

    const avatargo = () => {
        localStorage.setItem("renderAvatarChoiceBar", JSON.stringify(false))
        setRenderAvatarChoiceBar(false)
        localStorage.setItem("renderJoinStart", JSON.stringify(true))
        setRenderJoinStart(true)
    }

    const doNothing = () => {

    }

    let userBar;
    let avatarBar
    let goButton;
    let StartButton;
    let JoinButton;
    let joinBar;
    let orDiv;
    let joinUI;
    let beginButton;
    let GNFmessage;
    let aiPickerModal;
    let leaveLobbyButton;
    let leaveLobbyPrompt;

    if (gameNotFound) {
        GNFmessage = <div className = "GNFdiv">game not found!</div>
    }
    if (renderUserNameBar) {
        userBar = <form className="form1" id="searchform">
            <input
                type="text"
                className="inputSearch"
                id="addInput"
                placeholder="Enter  a Username..."
                onChange={searchHandler}
            />
        </form>
        goButton = <div className="gobutton" onClick = {() => searchgo()}><button style = {{fontFamily: 'arcadeclassic'}}>SUBMIT</button></div>
    }
    if (renderAvatarChoiceBar) {
        avatarBar = <AvatarBar handleAvatarClick = {handleAvatarClickLocal}>
                        </AvatarBar>
    }
    if (renderJoinStart) {
        StartButton = <div className = "startDiv"><button onClick = {() => handleStartClick()} className = "startButton">Start Game</button></div>
        joinBar = <form className="form2" id="searchform">
        <input
            type="text"
            className="inputJoin"
            id="addInput"
            placeholder="Enter a Game Code..."
            onChange={joinHandler}
        />
    </form>
        orDiv = <div className = "orclass">OR</div>
        JoinButton = <div className = "joinDiv"><button onClick = {() => handleJoinClick()} className = "joinButton">Join Game</button></div>
    }

    if (renderJoinUI) {
        const renderEmptySeat = (spot, seatInfo) => (
            <div className = {seatInfo.className}>
                <div className = {seatInfo.reverse ? "seatActionRow seatActionRowReverse" : "seatActionRow"}>
                    <button onClick = {() => handleSpotClick(spot)} className = "spotButton">Join Game</button>
                    <button
                        onClick = {() => setAiPickerSpot(spot)}
                        className = "openAiPickerButton"
                    >
                        +AI
                    </button>
                </div>
            </div>
        );

        const renderOccupiedSeat = (spot, seatInfo) => (
            <div className = {seatInfo.className}>
                <div className = {seatInfo.reverse ? "seatUserCard seatUserCardReverse" : "seatUserCard"}>
                    {!seatInfo.reverse && (
                        <div style = {{display: 'inline-block', width: 'fit-content', height: 'fit-content'}}>
                            <AvatarIcon codeKey = {seatInfo.logo}
                                width = '45px'
                                height = '45px'
                                style = {{display: 'inline-block'}}
                                handleAvatarClick = {() => doNothing()}>
                            </AvatarIcon>
                        </div>
                    )}
                    <div className = "otherUser">{seatInfo.user}</div>
                    {seatInfo.reverse && (
                        <div style = {{display: 'inline-block', width: 'fit-content', height: 'fit-content'}}>
                            <AvatarIcon codeKey = {seatInfo.logo}
                                width = '45px'
                                height = '45px'
                                style = {{display: 'inline-block'}}
                                handleAvatarClick = {() => doNothing()}>
                            </AvatarIcon>
                        </div>
                    )}
                </div>
            </div>
        );

        const renderSeat = (spot) => {
            const seatInfo = seatConfig[spot];
            if (seatInfo.user !== "") {
                return renderOccupiedSeat(spot, seatInfo)
            }
            return renderEmptySeat(spot, seatInfo)
        };

        let userCard1 = renderSeat(1)
        let userCard2 = renderSeat(2)
        let userCard3 = renderSeat(3)
        let userCard4 = renderSeat(4)

        if ((props.user1 !== "" && props.user2 !== "" && props.user3 !== "" && props.user4 !== "")) {
            beginButton = <div className = "beginDiv"><button onClick = {() => handleBeginClick()} className = "beginButton">Start Game</button></div>
        }
        leaveLobbyButton = <div className = "leaveLobbyFloatingRow"><button onClick = {() => setShowLeaveLobbyPrompt(true)} className = "leaveLobbyButton">Leave Lobby</button></div>
        joinUI = <div className = "joinUIclass">
            {userCard3}
            {userCard4}
            <img src = {TablePic} className = "table1" alt = "table"/>
            {userCard2}
            {userCard1}
            <div className = "gameCodeDisplay">Game Code: {props.gameCode}</div>
            {beginButton}
        </div>
    }

    if (showLeaveLobbyPrompt) {
        leaveLobbyPrompt = <div className = "aiPickerOverlay">
            <div className = "aiPickerModal">
                <div className = "aiPickerTitle">Leave This Lobby?</div>
                <button onClick = {() => leaveLobby()} className = "aiPickerChoice aiPickerChoiceDanger">Leave</button>
                <button onClick = {() => setShowLeaveLobbyPrompt(false)} className = "aiPickerBack">Go Back</button>
            </div>
        </div>
    }

    if (aiPickerSpot !== null) {
        aiPickerModal = <div className = "aiPickerOverlay">
            <div className = "aiPickerModal">
                <div className = "aiPickerTitle">Add AI To Seat {aiPickerSpot}</div>
                {AI_SEAT_OPTIONS.map((option) => (
                    <button
                        key = {option.id}
                        onClick = {() => handleAddAiClick(aiPickerSpot, option.id)}
                        className = "aiPickerChoice"
                    >
                        {option.label}
                    </button>
                ))}
                <button onClick = {() => setAiPickerSpot(null)} className = "aiPickerBack">Go Back</button>
            </div>
        </div>
    }

    return (
        <div className = "startPage">
            <div className = "startGameCard"  style = {{overflow: "hidden"}}>
                <div className = "tourneyDiv">Tourney Rules.</div>
                {userBar}
                {avatarBar}
                {goButton}
                {StartButton}
                {orDiv}
                {joinBar}
                {JoinButton}
                {joinUI}
                {aiPickerModal}
                {leaveLobbyPrompt}
                {GNFmessage}
            </div>
            {leaveLobbyButton}
        </div>
    );
};

export default StartPage
